import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ManageFeedbackTakers from '../components/tenant/ManageFeedbackTakers';
import ManageForms from '../components/tenant/ManageForms';
import ViewResponses from '../components/tenant/ViewResponses';
import ManageLinks from '../components/tenant/ManageLinks';
import BrandingSettings from '../components/tenant/BrandingSettings';
import CustomersTab from '../components/tenant/CustomersTab';
import StaffPerformanceTab from '../components/tenant/StaffPerformanceTab';
import AccountSettings from '../components/tenant/AccountSettings';
import LocationsTab from '../components/tenant/LocationsTab';
import LocationPerformanceTab from "../components/tenant/LocationPerformanceTab";
import HomeTab from "../components/tenant/HomeTab";
import LivePulse from "../components/tenant/LivePulse";
import { PRIMARY_COLOR } from "../contants/Colors";
import PWAInstallPrompt from "../components/PWAInstallPrompt";
import NotificationBell from "../components/NotificationBell";

const TABS = [
  { id: 'home',           icon: '🏠', label: 'Home' },
  { id: 'responses',      icon: '📊', label: 'Responses' },
  { id: 'customers',      icon: '👥', label: 'Customers' },
  { id: 'links',          icon: '🔗', label: 'Share Links' },
  { id: 'forms',          icon: '📋', label: 'Forms' },
  { id: 'staff',          icon: '👤', label: 'Staff' },
  { id: 'staff-perf',     icon: '🏆', label: 'Staff Performance' },
  { id: 'locations',      icon: '📍', label: 'Locations' },
  { id: 'locations-perf', icon: '⭐', label: 'Locations Performance' },
  { id: 'branding',       icon: '🎨', label: 'Branding' },
  { id: 'account',        icon: '⚙️', label: 'Account' },
];

export default function TenantDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab    = searchParams.get('tab')        || 'home';
  const responseId   = searchParams.get('responseId') || null;

  const handleLogout   = () => { logout(); navigate('/'); };
  const handleNavigate = (tabId) => setSearchParams({ tab: tabId });

  const getGreeting = () => {
    const h = new Date().getHours();
    if (h < 12) return 'Good morning';
    if (h < 17) return 'Good afternoon';
    return 'Good evening';
  };

  return (
      <div className="page">
        <nav className="navbar">
          <div className="container navbar-inner">
            <img
                src={'https://pub-267dd4744ace49cf8306de8e7c530c15.r2.dev/assets/Logo-Color.png'}
                style={{ width: 100 }}
                alt="logo"
            />
            <div className="navbar-actions">
            <span className="business-name" style={{ fontSize: 14, color: 'var(--text-muted)' }}>
              {user?.businessName}
            </span>
              <NotificationBell />
              <button className="btn btn-outline btn-sm" onClick={handleLogout}>Logout</button>
            </div>
          </div>
        </nav>

        <div className="container" style={{ paddingTop: 32 }}>
          <div className="page-header">
            <h2 style={{ marginBottom: 4, maxWidth: '80%' }}>{getGreeting()}, {user?.name} 👋</h2>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LivePulse label={''} color={PRIMARY_COLOR} />
              <p style={{ marginLeft: 10 }}>Feedback is live. Real voices. Real insights. Real time.</p>
            </div>
          </div>

          <div className="tabs" style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden', overflowX: 'auto' }}>
            {TABS.map(tab => (
                <button
                    key={tab.id}
                    className={`tab ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setSearchParams({ tab: tab.id })}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.2 }}>
                    <span style={{ fontSize: 18, marginBottom: 5 }}>{tab.icon}</span>
                    <span style={{ fontSize: 12 }}>{tab.label}</span>
                  </div>
                </button>
            ))}
          </div>

          {activeTab === 'home'           && <HomeTab onNavigate={handleNavigate} />}
          {activeTab === 'responses'      && (
              <ViewResponses
                  highlightResponseId={responseId}
                  onClearHighlight={() => setSearchParams({ tab: 'responses' })}
              />
          )}
          {activeTab === 'customers'      && <CustomersTab />}
          {activeTab === 'staff-perf'     && <StaffPerformanceTab />}
          {activeTab === 'links'          && <ManageLinks />}
          {activeTab === 'forms'          && <ManageForms />}
          {activeTab === 'staff'          && <ManageFeedbackTakers />}
          {activeTab === 'locations'      && <LocationsTab />}
          {activeTab === 'locations-perf' && <LocationPerformanceTab />}
          {activeTab === 'branding'       && <BrandingSettings />}
          {activeTab === 'account'        && <AccountSettings />}
        </div>

        <div style={{ height: 50 }} />
        <PWAInstallPrompt />
      </div>
  );
}